import { useEffect, useMemo, useState } from 'react';
import useDefaultTwoLevelFilter from '@/pages/opinion/components/FilterCommon/hooks/useDefaultTwoLevelFilter';
import {
  getGameStoreUserCountries,
  setGameStoreUserCountries,
} from '@/pages/opinion/services';

import { getCountryFlag } from '@/pages/home/_config/countries';

const formatOptions = (regionCountry: Array<any>) => {
  return regionCountry.map((item: any) => {
    const {
      country = [],
      region_abbre: regionValue,
      region_name_cn: textCN,
      region_name_en: text,
    } = item;
    const children =
      country?.map((subItem: any) => {
        const {
          country_name_abbre: countryValue,
          country_name_cn: textCN,
          country_name_en: text,
        } = subItem;
        return {
          ...subItem,
          value: countryValue?.toLocaleLowerCase?.(),
          text,
          textCN,
          icon: getCountryFlag(countryValue),
        };
      }) || [];
    return {
      ...item,
      value: regionValue,
      text,
      textCN,
      children,
    };
  });
};
export default function useRegionInfo({ originRegion, gameInfo }: any) {
  const regionOptions = useMemo(() => {
    return formatOptions(originRegion);
  }, [originRegion]);

  // 接口获取的默认值
  const [defaultRegionValue, setDefaultRegionValue] = useState<Array<string>>(
    [],
  );

  // 获取区域与城市的操作
  const {
    selectValue,
    setSelectValue,
    onChange: onRegionChange,
  } = useDefaultTwoLevelFilter({
    originalOptions: regionOptions,
    filterValue: defaultRegionValue,
    onlySecondLevelValue: true,
    beginWatch: true,
    dealwithDefaultValue: (value: Array<string>) => {
      return {
        value: Array.isArray(value) ? value : [],
        type: 'market',
      };
    },
  });

  // 区域选择器修改事件
  const regionChange = (tags: any) => {
    setSelectValue(tags);
    let { value } = onRegionChange(tags);
    let { edition_unified_id, id_type } = gameInfo;
    setGameStoreUserCountries({
      page: 'gamestore',
      uid: edition_unified_id,
      uid_type: id_type,
      countries: value,
    });
  };

  // 获取区域选择的默认值
  useEffect(() => {
    let { edition_unified_id, id_type } = gameInfo;
    getGameStoreUserCountries({
      page: 'gamestore',
      uid: edition_unified_id,
      uid_type: id_type,
    }).then((data: { countries: string[] }) => {
      let { countries } = data || { countries: [] };
      setDefaultRegionValue(countries || []);
    });
  }, [gameInfo]);

  const [useFilterRegion, setUseFilterRegion] = useState(true);

  // 需要过滤的值
  const filterCountries = useMemo(() => {
    const { value } = onRegionChange(selectValue);
    return useFilterRegion ? value : [];
  }, [selectValue, useFilterRegion]);

  return {
    regionOptions,
    selectValue,
    regionChange,
    filterCountries,
    useFilterRegion,
    setUseFilterRegion,
  };
}
